import { useEffect, useRef, useState } from "react";
import { useStores } from "../../store";
import Input from "../JobPost/input";
import PercentageInput from "../JobPost/PercentageInput";
import NumberSelector from "../JobPost/NumberSelector";
import { AiOutlineLeft } from "react-icons/ai";
import { PrimaryButton } from "../reusble_components/buttons/primaryButton";
import { useObserver } from "mobx-react";
import Popup from "./Components/skipPopup";
import { apiGet } from "../../api/api_methods";
import { getMockTestApplicants } from "../../api/recruiterAssessmentsApi";
import { RECRUITER_ASSESSMENTS_AVAILABLE_CATEGORIES } from "../../api/endpoints";
import JobShare from "./Components/Job";
import Loader from "../reusble_components/loader";
import { useLocation } from "react-router-dom";
import SelectWithDropDown from "../JobPost/selectWithDropDown";
import { MdInfoOutline } from "react-icons/md";
import { toJS } from "mobx";

export default function Mcq({ skip, isEdit, addMT }) {
  const { CommonStore, RecuiterStore, MockStore, PopupStore, UserStore } =
    useStores();
  const [showSkip, setShowSkip] = useState(skip ?? true);
  const [assessmentName, setAssessmentName] = useState(
    RecuiterStore.jobPostDetails.mcqTestDetails.testName || "",
  );
  const [noOfQuestions, setNoOfQuestions] = useState(
    RecuiterStore.jobPostDetails.mcqTestDetails.numberOfQuestions || "",
  );
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const id = query.get("id");
  const [cutOff, setCutOff] = useState(
    RecuiterStore.jobPostDetails.mcqTestDetails.cutOff || "",
  );
  const [aptitude, setAptitude] = useState(
    RecuiterStore.jobPostDetails.mcqTestDetails.sections[0].questions || "",
  );
  const [reasoning, setReasoning] = useState(
    RecuiterStore.jobPostDetails.mcqTestDetails.sections[2].questions || "",
  );
  const [technical, setTechnical] = useState(
    RecuiterStore.jobPostDetails.mcqTestDetails.sections[1].questions || "",
  );
  const [verbal, setVerbal] = useState(
    RecuiterStore.jobPostDetails.mcqTestDetails.sections[3].questions || "",
  );
  const [showPopup, setShowPopup] = useState(false);
  const [error, setError] = useState("");
  const [showError, setShowError] = useState(false);
  const [options, setOptions] = useState([]);
  const getoptions = async () => {
    const res = await apiGet(RECRUITER_ASSESSMENTS_AVAILABLE_CATEGORIES);
    if (res.status === 200 && res.body?.success) {
      const opt = (res.body.data || []).map((item) => {
        return { value: item, label: item };
      });
      setOptions(opt);
      // if (res.body.data.length > 0) {
      //   setAssessmentName(res.body.data[0]);
      // }
    }
  };

  const interviewSetting = [
    // {
    //   id: 1,
    //   label: "Candidate Video",
    //   name: "video",
    //   tooltip:
    //     "Enable this to record the candidate's video while they take the interview, helping recruiters assess their responses and body language.",
    // },
    // {
    //   id: 2,
    //   label: "Screen Recording",
    //   name: "screen",
    //   tooltip:
    //     "Enable this to require candidates to share their screen during the interview, ensuring transparency and integrity.",
    // },
    // {
    //   id: 3,
    //   label: "Allow Candidate to type answers",
    //   name: "typing",
    //   tooltip:
    //     "If enabled, candidates can type their responses in case of microphone issues or preference for written answers.",
    // },
    // {
    //   id: 4,
    //   label: "Allow to take Interview from Mobile",
    //   name: "mobile",
    //   tooltip:
    //     "Turn this on to allow candidates to take the interview from mobile devices or mobile browsers.",
    // },
    // {
    //   id: 5,
    //   label: "Reveal Actual answers",
    //   name: "actualAnswers",
    //   tooltip:
    //     "Enable this to let candidates view correct answers after completing their interview, useful for learning and feedback.",
    // },
    // {
    //   id: 6,
    //   label: "Show report to the candidate",
    //   name: "report",
    //   value: true,
    //   tooltip:
    //     "Allow candidates to access their interview results and performance reports after completion.",
    // },
    {
      id: 7,
      label: "Proxy Detection",
      name: "proxy",
      tooltip:
        "Activate AI-powered proxy detection to monitor candidate behavior and flag any suspicious activity during the interview.",
    },
    // {
    //   id: 11,
    //   label: "Allow to change tab",
    //   name: "tabChange",
    //   tooltip: "Allow candidates to change tabs during the interview.",
    // },
    // {
    //   id: 8,
    //   label: `Show job post in ${name()}`,
    //   name: "showJobPost",
    //   tooltip:
    //     "Make this job post visible on the Reaidy job seeker portal, allowing candidates from the platform to apply directly.",
    // },
    // {
    //   id: 9,
    //   label: "Resume",
    //   name: "resume",
    //   tooltip:
    //     "Automatically collect and attach the candidate's resume during the interview process for easy reference.",
    // },
    // {
    //   id: 10,
    //   label: "Candidate pay for the interview",
    //   name: "candidatePay",
    //   tooltip:
    //     "If enabled, candidates will be required to pay for the interview instead of the recruiter covering the cost.",
    // },
    {
      id: 15,
      label: "Show report to the candidate",
      name: "showReport",
      tooltip:
        "Allow candidates to access their MCQ test results and performance reports after completion.",
    },
  ];

  useEffect(() => {
    getoptions();
  }, []);
  const fetchMcqDetails = async () => {
    const res = await getMockTestApplicants(id, {});
    if ((res.status === 200 || res.status === 201) && res.body?.success) {
      const data = res.body.data?.invitation ?? res.body.data;
      if (!data) return;
      console.log(data);

      RecuiterStore.setMcqTestDetails("testName", data.mockTestName);
      setAssessmentName(data.mockTestName);
      RecuiterStore.setMcqTestDetails("numberOfQuestions", data.noOfQuestions);
      setNoOfQuestions(data.noOfQuestions);

      // Handle cutOff - remove % if present, then add it for store
      const cutOffValue =
        typeof data.cutOff === "string"
          ? data.cutOff.replace("%", "")
          : data.cutOff;
      RecuiterStore.setMcqTestDetails("cutOff", cutOffValue + "%");
      setCutOff(cutOffValue);

      // Update local state
      setAptitude(data.noOfAptitudeQuestions);
      setReasoning(data.noOfReasoningQuestions);
      setTechnical(data.noOfTechnicalQuestions);
      setVerbal(data.noOfVerbalQuestions);

      // Update store sections - this is critical for form fields to update
      RecuiterStore.setMcqSections("questions", 0, data.noOfAptitudeQuestions);
      RecuiterStore.setMcqSections("questions", 1, data.noOfTechnicalQuestions);
      RecuiterStore.setMcqSections("questions", 2, data.noOfReasoningQuestions);
      RecuiterStore.setMcqSections("questions", 3, data.noOfVerbalQuestions);

      // Update customSettings - iterate through array and set each setting individually
      if (data.customSettings && Array.isArray(data.customSettings)) {
        data.customSettings.forEach((setting) => {
          RecuiterStore.setJobPostCustomSettings(setting.name, setting.value);
        });
      }
    }
  };
  useEffect(() => {
    if (id && !isEdit) {
      fetchMcqDetails();
    }
  }, [id]);

  const setCutOffValue = (value) => {
    setCutOff(value);
    // Store cutOff with % appended to match the expected format
    RecuiterStore.setMcqTestDetails("cutOff", value + "%");
  };

  useEffect(() => {
    // alert(RecuiterStore.jobPostDetails.mcqTestDetails.testName)
    setAssessmentName(
      RecuiterStore.jobPostDetails.mcqTestDetails.testName || "",
    );
    setNoOfQuestions(
      RecuiterStore.jobPostDetails.mcqTestDetails.numberOfQuestions || "",
    );
    // Remove % from cutOff when syncing from store to local state
    const cutOffValue = RecuiterStore.jobPostDetails.mcqTestDetails.cutOff
      ? String(RecuiterStore.jobPostDetails.mcqTestDetails.cutOff).replace(
          "%",
          "",
        )
      : "";
    setCutOff(cutOffValue);
    setAptitude(
      RecuiterStore.jobPostDetails.mcqTestDetails.sections[0].questions || "",
    );
    setReasoning(
      RecuiterStore.jobPostDetails.mcqTestDetails.sections[2].questions || "",
    );
    setTechnical(
      RecuiterStore.jobPostDetails.mcqTestDetails.sections[1].questions || "",
    );
    setVerbal(
      RecuiterStore.jobPostDetails.mcqTestDetails.sections[3].questions || "",
    );
  }, [RecuiterStore.jobPostDetails.mcqTestDetails]);
  const isFirstRender = useRef(true); // Track the initial render
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false; // Mark the first render as completed
      setAptitude(
        RecuiterStore.jobPostDetails.mcqTestDetails.sections[0].questions,
      );
      setReasoning(
        RecuiterStore.jobPostDetails.mcqTestDetails.sections[2].questions,
      );
      setVerbal(
        RecuiterStore.jobPostDetails.mcqTestDetails.sections[3].questions,
      );
      setTechnical(
        RecuiterStore.jobPostDetails.mcqTestDetails.sections[1].questions,
      );
      return; // Skip execution on the first render
    }

    // If assessment is "Aptitude", set technical to total questions without division
    if (RecuiterStore.jobPostDetails.mcqTestDetails.testName === "Aptitude") {
      setAptitude(0);
      setReasoning(0);
      setVerbal(0);
      setTechnical(Number(noOfQuestions) || 0);
      RecuiterStore.setMcqSections("questions", 0, 0);
      RecuiterStore.setMcqSections("questions", 1, Number(noOfQuestions) || 0);
      RecuiterStore.setMcqSections("questions", 2, 0);
      RecuiterStore.setMcqSections("questions", 3, 0);
    } else {
      const dividedValue = Math.floor(noOfQuestions / 4);
      const remaider = noOfQuestions % 4;
      setAptitude(dividedValue);
      setReasoning(dividedValue);
      setVerbal(dividedValue);
      setTechnical(dividedValue + remaider);
      RecuiterStore.setMcqSections("questions", 0, dividedValue);
      RecuiterStore.setMcqSections("questions", 1, dividedValue + remaider);
      RecuiterStore.setMcqSections("questions", 2, dividedValue);
      RecuiterStore.setMcqSections("questions", 3, dividedValue);
    }

    if (Number(noOfQuestions) < 20) {
      setError("the number of questions should be min 20");
      setShowError(true);
    } else {
      setError("");
    }
    if (
      Number(RecuiterStore.jobPostDetails.mcqTestDetails.numberOfQuestions) < 20
    ) {
      setError(
        "The total number of questions should always be with a minimum of 20.",
      );
      setShowError(true);
    } else {
      setError("");
    }
    setShowError(true);
  }, [
    noOfQuestions,
    RecuiterStore.jobPostDetails.mcqTestDetails.numberOfQuestions,
    RecuiterStore.jobPostDetails.mcqTestDetails.testName,
  ]);

  const handleNoOfQuestions = () => {
    const totalQuestions =
      Number(RecuiterStore.jobPostDetails.mcqTestDetails.numberOfQuestions) ||
      0;

    // If assessment is "Aptitude", set technical to total questions without division
    if (RecuiterStore.jobPostDetails.mcqTestDetails.testName === "Aptitude") {
      setAptitude(0);
      setReasoning(0);
      setVerbal(0);
      setTechnical(totalQuestions);
      RecuiterStore.setMcqSections("questions", 0, 0);
      RecuiterStore.setMcqSections("questions", 1, totalQuestions);
      RecuiterStore.setMcqSections("questions", 2, 0);
      RecuiterStore.setMcqSections("questions", 3, 0);
    } else {
      const dividedValue = Math.floor(totalQuestions / 4);
      const remaider = totalQuestions % 4;
      setAptitude(dividedValue);
      setReasoning(dividedValue);
      setVerbal(dividedValue);
      setTechnical(dividedValue + remaider);
      RecuiterStore.setMcqSections("questions", 0, dividedValue);
      RecuiterStore.setMcqSections("questions", 1, dividedValue + remaider);
      RecuiterStore.setMcqSections("questions", 2, dividedValue);
      RecuiterStore.setMcqSections("questions", 3, dividedValue);
    }

    if (totalQuestions < 20) {
      setError("the number of questions should be min 20");
      setShowError(true);
    } else {
      setError("");
    }
    if (totalQuestions < 20) {
      setError(
        "The total number of questions should always be with a minimum of 20.",
      );
      setShowError(true);
    } else {
      setError("");
    }
    setShowError(true);
  };

  // useEffect(() => {
  //   const totalQuestions = Number(aptitude) + Number(reasoning) + Number(verbal) + Number(technical);
  //   if (totalQuestions % 2 === 0) {
  //     setNoOfQuestions(totalQuestions);
  //     RecuiterStore.setMcqTestDetails("numberOfQuestions", totalQuestions);
  //     setError("");
  //   } else {
  //     setError("The total number of questions should always be an even number.");
  //   }
  // }, [aptitude, reasoning, technical, verbal]);
  const [MCQpopup, setMCQpopup] = useState(false);
  const [loader, setLoader] = useState(false);

  const handleMCQSubmit = async (e) => {
    e.preventDefault();
    if (
      RecuiterStore.jobPostDetails.mcqTestDetails.sections[0].questions +
        RecuiterStore.jobPostDetails.mcqTestDetails.sections[1].questions +
        RecuiterStore.jobPostDetails.mcqTestDetails.sections[2].questions +
        RecuiterStore.jobPostDetails.mcqTestDetails.sections[3].questions !==
      Number(RecuiterStore.jobPostDetails.mcqTestDetails.numberOfQuestions)
    ) {
      alert(
        "the sum of all sections should be equal to the total number of questions",
      );
      return;
    }
    // alert("Hello");
    if (Number(noOfQuestions) < 20) {
      alert("the number of questions should be min 20");
      return;
    }
    if (Number(noOfQuestions) < 20) {
      alert(
        "The total number of questions should always be with a minimum of 20.",
      );
      return;
    }
    // alert(assessmentName)

    if (assessmentName === "") {
      alert("Select Assessment");
      return;
    }
    if (!showSkip) {
      setLoader(true);
      const res = await MockStore.createMocktestInvitation(
        assessmentName,
        noOfQuestions,
        cutOff,
        aptitude,
        reasoning,
        verbal,
        technical,
        id,
        RecuiterStore.jobPostDetails.customSettings,
      );

      if (res) {
        setLoader(false);

        setMCQpopup(true);
      } else {
        setLoader(false);

        setMCQpopup(false);
      }
    }
    console.log(
      "MCQ",
      assessmentName,
      noOfQuestions,
      cutOff,
      aptitude,
      reasoning,
      technical,
      verbal,
    );
    if (assessmentName === "") {
      alert("Select Assessment");
      return;
    } else {
      RecuiterStore.setMcqTestDetails("testName", assessmentName);
    }
    CommonStore.setProgress(3);
    CommonStore.setLabelActive(2, true);
    RecuiterStore.setMcqTestDetails("skipped", false);
    RecuiterStore.setMcqTestDetails(
      "numberOfQuestions",
      RecuiterStore.jobPostDetails.mcqTestDetails.numberOfQuestions,
    );
    RecuiterStore.setMcqTestDetails("cutOff", cutOff);
    RecuiterStore.setMcqSections("questions", 0, aptitude);
    RecuiterStore.setMcqSections("questions", 1, technical);
    RecuiterStore.setMcqSections("questions", 2, reasoning);
    RecuiterStore.setMcqSections("questions", 3, verbal);
  };
  const handleCopyClick = () => {
    // Create a textarea element to temporarily hold the text
    const textarea = document.createElement("textarea");
    textarea.value = MockStore.mockTestInvitationLink;

    // Append the textarea to the document
    document.body.appendChild(textarea);

    // Select the text in the textarea and copy it to the clipboard
    textarea.select();
    document.execCommand("copy");

    // Remove the textarea from the document
    document.body.removeChild(textarea);
    window.alert("link copied");
  };
  const handlePopUpVisible = () => {
    setMCQpopup(false);
  };

  const link = () => {
    if (
      !MockStore.mockTestInvitationLink ||
      !MockStore.mockTestInvitationClientLink
    ) {
      return {
        jobPostLink: "MCQ test link not available yet",
        clientLink: "MCQ test link not available yet",
      };
    }
    const jobPostLink = MockStore.mockTestInvitationLink;
    const clientLink = MockStore.mockTestInvitationClientLink;
    return { jobPostLink: jobPostLink, clientLink: clientLink };
  };

  const getLabel = (name) => {
    return interviewSetting.find((setting) => setting.name === name)?.label;
  };

  const getTooltip = (name) => {
    return interviewSetting.find((setting) => setting.name === name)?.tooltip;
  };

  return useObserver(() => (
    <div
      className={`w-full overflow-hidden ${
        !showSkip ? " flex flex-col items-center justify-center" : null
      }  `}
    >
      <Loader loader={loader} />
      <JobShare
        link={link()}
        emailBody={`Here is the MCQ Test link : ${MockStore.mockTestInvitationLink}`}
        emailSubject={""}
        isPopupVisible={MCQpopup}
        handlePopUpVisible={handlePopUpVisible}
        interview="MCQ Test"
      />

      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleMCQSubmit(e);
        }}
        className="md:w-[90%] lg:w-[85%] w-[86%] flex flex-col mx-auto gap-4 mt-4 "
      >
        <div
          className={` w-[100%] flex ${
            showSkip ? "justify-between" : "justify-center"
          }`}
        >
          {/* {showSkip && <p></p>} */}
          <p
            className={`text-xl font-semibold text-black-500 md:block  mt-10 lg:block block ${
              showSkip && " "
            }`}
          >
            {id ? "Update" : "Add"} MCQ's test
          </p>
          {showSkip && (
            <>
              {RecuiterStore.jobPostDetails.mcqTestDetails.skipped && isEdit ? (
                <div className="flex gap-2 flex-col">
                  {/* <button
                  type="button"
                  onClick={() => setShowPopup(true)}
                  className="text-gray-400 underline cursor-not-allowed"
                >
                  Skip Section
                </button> */}
                  <p className="text-primary">This section is skipped</p>
                </div>
              ) : (
                <button
                  type="button"
                  onClick={() => setShowPopup(true)}
                  className="text-primary underline mt-10 font-bold underline-offset-2"
                >
                  Skip Section
                </button>
              )}
            </>
          )}
        </div>
        {/* {showSkip && (
          <p className="text-text_warningColor font-semibold flex items-center gap-2 text-lg">
            <MdOutlineWarningAmber />
            This feature will be implemented in future. Please skip this section
            for now.
          </p>
        )} */}
        <div className="flex w-full md:flex-row lg:flex-row flex-col  gap-x-10 justify-between">
          <div className="md:w-full  w-full tc6:w-full ">
            {" "}
            <SelectWithDropDown
              label="Name of the assessment"
              placeholder="Select Assessment"
              value={assessmentName}
              action={(e) => {
                if (RecuiterStore.jobPostDetails.mcqTestDetails.skipped) {
                  RecuiterStore.setMcqTestDetails("skipped", false);
                  CommonStore.setLabelSkipped(1, false);
                }
                setAssessmentName(e.target.value);
                RecuiterStore.setMcqTestDetails("testName", e.target.value);
                // Recalculate question distribution when assessment name changes
                handleNoOfQuestions();
              }}
              options={options}
            />
          </div>
          <div className="w-full flex flex-col justify-center gap-1">
            <div
              style={{
                position: "relative",
                display: "inline-block",
                width: "100%",
              }}
            >
              <Input
                label="No. of Questions"
                mcq={true}
                res={true}
                regex={true}
                regexFormula={/^[0-9]*$/}
                type="number"
                max={1000}
                placeholder="Enter number of questions"
                defaultValue={
                  RecuiterStore.jobPostDetails.mcqTestDetails.numberOfQuestions
                }
                isMCQ={true}
                action={(e) => {
                  if (RecuiterStore.jobPostDetails.mcqTestDetails.skipped) {
                    RecuiterStore.setMcqTestDetails("skipped", false);
                    CommonStore.setLabelSkipped(1, false);
                  }
                  setNoOfQuestions(e.target.value);
                  RecuiterStore.setMcqTestDetails(
                    "numberOfQuestions",
                    e.target.value,
                  );
                  handleNoOfQuestions();
                }}
                info={true}
                infoText="The total number of questions should always be an even number and above 20."
                style={{ paddingRight: "30px" }} // Add space for the icon
              />
              <div className="md:top-[50px] lg:top-[50px] top-[50px]  right-1 absolute">
                {/* <RiArrowDropDownLine
                  style={{
                    position: "absolute",
                    right: "10px",
                    // top: "72%",
                    transform: "translateY(-50%)",
                    color: "#000",
                    pointerEvents: "none", // Prevents interaction with the icon
                  }}
                  size={20}
                /> */}
              </div>
            </div>
            {showError && <p className="text-red-500 text-sm">{error}</p>}
          </div>
          <div className="md:w-full lg:w-[40%] w-full relative">
            <PercentageInput
              label="Cut off(%)"
              type="number"
              regex={true}
              regexFormula={/^[0-9]*$/}
              placeholder="Enter cut-off for mcq test"
              value={String(RecuiterStore.jobPostDetails.mcqTestDetails.cutOff)}
              setValue={setCutOffValue}
              tooltip="The minimum percentage required to pass the test"
              fit={true}
              action={(e) => {
                if (RecuiterStore.jobPostDetails.mcqTestDetails.skipped) {
                  RecuiterStore.setMcqTestDetails("skipped", false);
                  CommonStore.setLabelSkipped(1, false);
                }
                setCutOffValue(e.target.value);
              }}
              className="pr-10" // Ensures text doesn't overlap the icon
            />
            {/* <div className="md:top-10 lg:top-10 top-[40px]  right-1 absolute">
              <RiArrowDropDownLine
                style={{
                  position: "absolute",
                  right: "10px",
                  // top: "38%",
                  // transform: "translateY(-50%)",
                  color: "#000",

                  pointerEvents: "none", // Prevents interaction with the icon
                }}
                size={20}
              />
            </div> */}
          </div>
        </div>
        <div className="w-full flex flex-col border bg-[#EFEFEF] rounded-lg p-5">
          <div className="mb-5">
            <p>
              Questions{" "}
              <span className="text-xs text-primary ">
                (You can change No.of Questions for each section)
              </span>
            </p>
          </div>

          <div className="w-full flex md:flex-row md:flex-wrap md:overflow-x-auto lg:flex-row flex-col items-center justify-between">
            {RecuiterStore.jobPostDetails.mcqTestDetails.testName !==
            "Aptitude" ? (
              <div className="md:min-w-[220px] md:max-w-[270px] lg:w-[23%] w-full">
                <NumberSelector
                  label="Aptitude"
                  regex={true}
                  regexFormula={/^[0-9]*$/}
                  defaultValue={
                    RecuiterStore.jobPostDetails.mcqTestDetails.sections[0]
                      .questions
                  }
                  value={
                    RecuiterStore.jobPostDetails.mcqTestDetails.sections[0]
                      .questions
                  }
                  action={(e) => {
                    if (Number(noOfQuestions) >= 10000000) return;
                    setAptitude(e);
                    RecuiterStore.setMcqSections("questions", 0, e);
                  }}
                />
              </div>
            ) : null}
            {RecuiterStore.jobPostDetails.mcqTestDetails.testName !==
            "Aptitude" ? (
              <div className="md:min-w-[220px] md:max-w-[270px] lg:w-[23%] w-full">
                <NumberSelector
                  label="Reasoning"
                  regex={true}
                  regexFormula={/^[0-9]*$/}
                  defaultValue={
                    RecuiterStore.jobPostDetails.mcqTestDetails.sections[2]
                      .questions
                  }
                  value={
                    RecuiterStore.jobPostDetails.mcqTestDetails.sections[2]
                      .questions
                  }
                  action={(e) => {
                    if (Number(noOfQuestions) >= 10000000) return;

                    setReasoning(e);
                    RecuiterStore.setMcqSections("questions", 2, e);
                  }}
                />
              </div>
            ) : null}
            {RecuiterStore.jobPostDetails.mcqTestDetails.testName !==
            "Aptitude" ? (
              <div className="md:min-w-[220px] md:max-w-[270px] lg:w-[23%] w-full">
                <NumberSelector
                  label="Verbal"
                  regex={true}
                  regexFormula={/^[0-9]*$/}
                  defaultValue={
                    RecuiterStore.jobPostDetails.mcqTestDetails.sections[3]
                      .questions
                  }
                  value={
                    RecuiterStore.jobPostDetails.mcqTestDetails.sections[3]
                      .questions
                  }
                  action={(e) => {
                    if (Number(noOfQuestions) >= 10000000) return;

                    setVerbal(e);
                    RecuiterStore.setMcqSections("questions", 3, e);
                  }}
                />
              </div>
            ) : null}
            <div className="md:min-w-[220px] md:max-w-[270px]  lg:w-[23%] w-full">
              <NumberSelector
                label={`${RecuiterStore.jobPostDetails.mcqTestDetails.testName === "Aptitude" ? "Aptitude" : "Technical"}`}
                regex={true}
                regexFormula={/^[0-9]*$/}
                defaultValue={
                  RecuiterStore.jobPostDetails.mcqTestDetails.sections[1]
                    .questions
                }
                value={
                  RecuiterStore.jobPostDetails.mcqTestDetails.sections[1]
                    .questions
                }
                action={(e) => {
                  if (Number(noOfQuestions) >= 10000000) return;

                  setTechnical(e);
                  RecuiterStore.setMcqSections("questions", 1, e);
                }}
              />
            </div>
          </div>
        </div>

        {!showSkip && (
          <div className="w-full flex flex-col border bg-[#EFEFEF] rounded-lg p-5">
            <h1 className="text-lg font-semibold">Additional Settings</h1>
            <div className="w-full flex flex-col gap-2">
              <div className="w-full flex-col grid md:grid-cols-3 grid-cols-1 gap-2">
                {RecuiterStore.jobPostDetails.customSettings
                  ?.filter((setting) =>
                    interviewSetting.find((s) => s.name === setting.name),
                  )
                  .map((setting, index) => (
                    <div
                      key={index}
                      className="bg-white rounded-lg border border-gray-300 p-3 flex items-center justify-between relative"
                    >
                      <div className="flex items-center gap-1">
                        <span className="text-gray-700 font-medium text-xs">
                          {getLabel(setting.name)}
                          {setting.name === "proxy" && (
                            <span className="ml-1 px-2 py-1 text-[8px] bg-blue-100 text-blue-600 rounded-full">
                              BETA
                            </span>
                          )}
                        </span>
                        {/* Info Icon for all options */}
                        <div className="group relative flex items-center">
                          <MdInfoOutline className="text-primary cursor-pointer" />
                          <div className="absolute hidden group-hover:flex items-center bottom-full mb-2 left-1/2 transform -translate-x-1/2 bg-[#EFEFEF] bg-opacity-100 z-20 text-black text-[12px] leading-5 p-3 rounded-lg w-60">
                            {getTooltip(setting.name)}
                            <div className="w-0 h-0 border-[10px] absolute -bottom-2 left-1/2 transform -translate-x-1/2 border-x-transparent border-t-[#EFEFEF] border-b-0"></div>
                          </div>
                        </div>
                      </div>

                      <button
                        type="button"
                        onClick={() => {
                          if (setting.name === "proxy" && !setting.value) {
                            // If turning on proxy, automatically turn off mobile access
                            RecuiterStore.setJobPostCustomSettings(
                              "mobile",
                              false,
                            );
                          } else if (
                            setting.name === "mobile" &&
                            !setting.value
                          ) {
                            // Check if proxy is enabled before allowing mobile access
                            const isProxyEnabled =
                              RecuiterStore.jobPostDetails.customSettings.find(
                                (s) => s.name === "proxy",
                              )?.value;

                            if (isProxyEnabled) {
                              alert(
                                "Cannot enable mobile access while proxy detection is active. Please disable proxy detection first.",
                              );
                              return;
                            }
                          }
                          RecuiterStore.setJobPostCustomSettings(
                            setting.name,
                            !setting.value,
                          );
                        }}
                        className={`w-8 h-4 flex items-center p-[2px] rounded-full transition-colors duration-300 ${
                          setting.value ? "bg-orange-500" : "bg-gray-300"
                        }`}
                      >
                        <div
                          className={`w-3 h-3 bg-white rounded-full shadow-md transform transition-transform duration-300 ${
                            setting.value ? "translate-x-3.5" : "translate-x-0"
                          }`}
                        ></div>
                      </button>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        )}
        {/* {!showSkip && MockStore.mockTestInvitationLink !== null && (
          <div className="flex w-full md:w-[70%] lg:w-[65%]">
            <textarea
              className="w-full h-[100px] resize-none"
              value={MockStore.mockTestInvitationLink}
            />
            <span
              class="flex text-gray-800 cursor-pointer w-5 h-5 hover:text-gray-400 duration-200"
              onClick={handleCopyClick}>
              {" "}
              <AiOutlineCopy className="text-xl active:text-primary" />
            </span>
          </div>
        )} */}

        <div
          className={`w-full flex  ${
            showSkip ? "justify-between" : "justify-end"
          } items-start mt-8 mb-20 md:mb-0`}
        >
          {showSkip && (
            <button
              type="button"
              className="flex items-center justify-between ml-6 md:mt-12 lg:mt-12 mt-8 text-primary gap-2 mb-24"
              onClick={() => {
                CommonStore.setProgress(1);
              }}
            >
              <AiOutlineLeft /> Back
            </button>
          )}
          {showSkip ? (
            <div className="mt-7 md:mt-12 lg:mt-12  mb-20">
              <PrimaryButton
                buttonName={"Next"}
                type={
                  RecuiterStore.jobPostDetails.mcqTestDetails.skipped
                    ? "button"
                    : "submit"
                }
                onClick={() => {
                  if (RecuiterStore.jobPostDetails.mcqTestDetails.skipped) {
                    RecuiterStore.setMcqTestDetails("skipped", true);
                    CommonStore.setProgress(3);
                    CommonStore.setLabelActive(2, false);
                    CommonStore.setLabelSkipped(2, true);
                  } else {
                    CommonStore.setLabelSkipped(2, false);
                  }
                }}
                padding={10}
                width="w-fit"
                rounded="lg"
              />
            </div>
          ) : (
            <div className="mt-6  mb-20">
              <PrimaryButton
                buttonName={"Submit"}
                type={"submit"}
                padding={10}
                width="w-fit"
              />
            </div>
          )}
        </div>
      </form>
      {showPopup && (
        // <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-400 bg-opacity-50">
        //   <div className="bg-[#F3F3F3] p-6 rounded-lg shadow-lg w-[90%] max-w-md">
        //     <div className="flex flex-col items-center">
        //       <MdWarning className="text-3xl text-gray-500" />
        //       <p className="  mt-4">
        //         Please fill in the details to move to the next section / click
        //         on skip section
        //       </p>
        //     </div>
        //     <div className="mt-6 w-[60%] mx-auto flex justify-between">
        //       <button
        //         className="underline"
        //         onClick={() => {
        //           RecuiterStore.setMcqTestDetails("skipped", true);
        //           setShowPopup(false);
        //           CommonStore.setProgress(2);
        //           CommonStore.setLabelActive(1, false);
        //         }}>
        //         Skip Section
        //       </button>
        //       <button
        //         className="text-primary underline"
        //         onClick={() => setShowPopup(false)}>
        //         Fill details
        //       </button>
        //     </div>
        //   </div>
        // </div>
        <Popup
          onSkip={() => {
            RecuiterStore.setMcqTestDetails("skipped", true);
            setShowPopup(false);
            CommonStore.setProgress(3);
            CommonStore.setLabelActive(2, false);
            CommonStore.setLabelSkipped(2, true);
          }}
          onFillDetails={() => setShowPopup(false)}
        />
      )}
    </div>
  ));
}
